import { render, staticRenderFns } from "./pfh-outside-link.vue?vue&type=template&id=9b648550&"
import script from "./pfh-outside-link.vue?vue&type=script&lang=js&"
export * from "./pfh-outside-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports